// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"84":"b382b735","711":"60e9b933"}[chunkId] + ".css";
};